// extracted by mini-css-extract-plugin
module.exports = {"tabs":"GroupCover_style_tabs__26F71","tab":"GroupCover_style_tab__2rtq1"};